"use client";
import { useReportWebVitals } from "next/web-vitals";

type GtagEventParams = Record<string, string | number | boolean>;

declare global {
  interface Window {
    gtag?: (command: "event", action: string, config?: GtagEventParams) => void;
  }
}

export default function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", `web_vitals_${metric.name.toLowerCase()}`, {
        value: Math.round(metric.value),
        event_category: "Web Vitals",
        event_label: metric.id,
        non_interaction: true,
      });
    }

  });
  
  return null;
}
